import {injectable} from "tsyringe";
import {RecolorKeywordCommand} from "../commands/recolor-keyword.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {Keyword} from "../domain/entities/keyword.entity";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

@injectable()
@transformer({
    source: RecolorKeywordCommand,
    target: `dto`
})
export class RecolorKeywordCommandToDtoTransformer extends AbstractCommandToDtoTransformer<Keyword> {

    protected async toDTO(keyword: Keyword): Promise<DataTransferObject> {
        return {
            uid: keyword.uid,
            color: keyword.color,
        };
    }
}